import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Text } from '@chakra-ui/react';

import Breadcrumb from '../components/layout/Breadcrumb';
import ProductGrid from '../components/product/ProductGrid';
import { useUserContext } from '../contexts/UserContext';
import { useShopUI } from '../contexts/ShopUIContext';
import useCatalog from '../hooks/useCatalog';

const condensed = { fontWeight: 700, textTransform: 'uppercase', sx: { fontStretch: '75%' } };

// Wishlist (design-system.md §5.7)
const Favorites = () => {

  const navigate = useNavigate();
  const { currentUser } = useUserContext();
  const { favorites } = useShopUI();
  const { products, loading } = useCatalog();
  const saved = useMemo(() => products.filter(p => favorites.has(p._id)), [products, favorites]);

  return (
    <Box>
      <Breadcrumb items={[{ label: 'Home', to: '/' }, { label: 'Wishlist' }]} />
      <Box px={{ base: '12px', md: '40px' }} pt={{ base: '20px', md: '32px' }} pb={{ base: '32px', md: '56px' }} >
        <Box display='flex' alignItems='center' justifyContent='center' flexDirection='column' >
          <Text as='h1' fontSize={{ base: '28px', md: '36px' }} {...condensed} >My wishlist</Text>
          {currentUser && saved.length > 0 && <Text mt='4px' fontSize='14px' color='raano.muted' >{saved.length} {saved.length === 1 ? 'item' : 'items'} saved</Text>}
        </Box>

        {!currentUser ? (
          <Box mt='24px' maxWidth='560px' mx='auto' textAlign='center' >
            <Box bg='#E6F1FA' color='#1F4E79' py='14px' px='16px' fontSize='15px' >Log in to save items to your wishlist.</Box>
            <Button mt='20px' variant='ink' height='48px' px='40px' fontSize='16px' onClick={() => navigate('/login', { state: { from: '/favorites' } })} >Log in</Button>
          </Box>
        ) : !loading && saved.length === 0 ? (
          <Box mt='24px' maxWidth='560px' mx='auto' textAlign='center' >
            <Box bg='#E6F1FA' color='#1F4E79' py='14px' px='16px' fontSize='15px' >There are no items in your wishlist. Tap the heart on any product to save it here.</Box>
            <Button mt='20px' variant='ink' height='48px' px='40px' fontSize='16px' onClick={() => navigate('/search', { state: {} })} >Shop all</Button>
          </Box>
        ) : (
          <Box mt={{ base: '20px', md: '32px' }} >
            <ProductGrid products={saved} loading={loading} skeletons={4} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Favorites;
